import { ShippingInfo } from '@app/models/prices';
import { createAction, props } from '@ngrx/store';

export const load = createAction('[Shipping Prices] Load');

export const loadSuccess = createAction('[Shipping Prices] Load Success', props<{ prices: ShippingInfo }>());

export const loadFailed = createAction('[Shipping Prices] Load Failed');

// export const setCountry = createAction(
// 	'[Shipping Prices] Set Filter Location',
// 	props<{ coutryId: ShippingCountryId }>()
// );
